const commonConfig = {
  confirm_btn: '确认',
  cancel_btn: '取消',
  not_data: '暂无数据',
  updata_data_suc: '数据更新成功',
  updata_data_fail: '数据更新失败',
  online: '在线',
  off_line: '离线',
  waiting: '连线中...'
};

export default commonConfig;
